// @ai-generated 2026-07-21T03:45:01+00:00 by philipp.kammerer@synqony.com using claude-fable-5
import { useState } from 'react';
import { useNotificationHub } from '@Contexts/notificationHub';
import { type EnumNotificationModule } from '@Model';
import {
    Badge,
    Button,
    Checkbox,
    FlexColumn,
    FlexRow,
    ScrollContainer,
    Separator,
    StyledParagraph,
    Tooltip,
    useTranslate,
} from '@synqo/frontend-component-library';
import { IconSettings } from '@tabler/icons-react';
import { NotificationRow } from './NotificationRow';
import { NotificationSettingsPanel } from './NotificationSettingsPanel';
import styles from './NotificationHubButton.module.css';

export function NotificationHubDropdown() {
    const i18n = useTranslate('NotificationHub');
    const [settingsView, setSettingsView] = useState<{ module?: EnumNotificationModule }>();
    const {
        notifications,
        unreadCount,
        isLoading,
        onlyUnread,
        setOnlyUnread,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        acknowledge,
        acknowledgeAll,
    } = useNotificationHub();

    const emptyStateLabel = onlyUnread
        ? i18n('Keine ungelesenen Benachrichtigungen.')
        : i18n('Keine Benachrichtigungen.');

    return (
        <>
            <div
                onClick={(event) => {
                    if (!(event.target as HTMLElement).closest('[data-closes-popover]')) {
                        event.stopPropagation();
                    }
                }}
            >
                {settingsView ? (
                    <NotificationSettingsPanel
                        pinnedModule={settingsView.module}
                        onBack={() => setSettingsView(undefined)}
                    />
                ) : (
                    <FlexColumn justify="start" align="stretch" gap="sm" width="392px">
                        <FlexRow justify="space-between" align="center" className={styles.header}>
                            <FlexRow align="center" gap="xs">
                                <span className={styles.headerTitle}>{i18n('Benachrichtigungen')}</span>
                                {unreadCount > 0 && (
                                    <Badge variant="accent" type="counter" size="xxs">
                                        {unreadCount}
                                    </Badge>
                                )}
                            </FlexRow>
                            <FlexRow align="center" gap="xs">
                                <Button
                                    appearance="transparent"
                                    className={styles.markAllButton}
                                    locked={unreadCount === 0}
                                    onClick={() => void acknowledgeAll()}
                                >
                                    {i18n('Alle als gelesen')}
                                </Button>
                                <Tooltip label={i18n('Benachrichtigungseinstellungen')}>
                                    <button
                                        type="button"
                                        aria-label={i18n('Benachrichtigungseinstellungen')}
                                        className={styles.settingsButton}
                                        onClick={() => setSettingsView({})}
                                    >
                                        <IconSettings size={16} />
                                    </button>
                                </Tooltip>
                            </FlexRow>
                        </FlexRow>
                        <div className={styles.filterRow}>
                            <Checkbox
                                name="notification_hub_only_unread"
                                value={onlyUnread}
                                onChange={(value) => {
                                    setOnlyUnread(value);
                                    return true;
                                }}
                                label={i18n('Nur ungelesene anzeigen')}
                            />
                        </div>
                        <Separator />
                        <ScrollContainer height="380px" scrollbars="y">
                            <div className={styles.list}>
                                <FlexColumn justify="start" align="stretch" gap="none">
                                    {isLoading && (
                                        <StyledParagraph>{i18n('Lade Benachrichtigungen …')}</StyledParagraph>
                                    )}
                                    {!isLoading && notifications.length === 0 && (
                                        <div className={styles.emptyState}>
                                            <StyledParagraph>{emptyStateLabel}</StyledParagraph>
                                        </div>
                                    )}
                                    {notifications.map((notification) => (
                                        <NotificationRow
                                            key={notification.id}
                                            notification={notification}
                                            onAcknowledge={acknowledge}
                                            onOpenSettings={(module) => setSettingsView({ module })}
                                        />
                                    ))}
                                    {hasNextPage && (
                                        <Button
                                            appearance="transparent"
                                            size="xl"
                                            className={styles.loadMoreButton}
                                            locked={isFetchingNextPage}
                                            onClick={() => void fetchNextPage()}
                                        >
                                            {i18n('Mehr laden')}
                                        </Button>
                                    )}
                                </FlexColumn>
                            </div>
                        </ScrollContainer>
                    </FlexColumn>
                )}
            </div>
        </>
    );
}
